module.exports = __webpack_public_path__ + "static/media/cd2-icon-non-compliant.9b379871.svg";